<app-tabla
  [totalCount]="totalCount"
  [datos]="listadoCategorias"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay categorías' }"
></app-tabla>
